<!-- Google Tag Manager -->

(function(w,d,s,l,i){
  w[l]=w[l]||[];
  w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
  j.async=true;
  j.defer=true;
  j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5MTF8B4');

// Google Analytics & Ads
window.dataLayer = window.dataLayer || [];
function gtag(){ dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', 'G-05H151PLF9');
gtag('config', 'AW-706341742');

// Klaviyo init
var _k = window._k || [];
_k.push = _k.push || function(){ (_k.pushQueue = _k.pushQueue || []).push(arguments); };

var klaviyo = window.klaviyo || [];
klaviyo.init?.({
  account: "T6n3x3",
  list: "UG7Eez",
  platform: "shopify"
});
klaviyo.enable?.("backinstock", {
  trigger: {
    product_page_text: "Krijg een melding wanneer dit weer op voorraad is",
    product_page_class: "button",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false
  },
  modal: {
    headline: "{product_name}",
    body_content: "Laat je e-mailadres achter en ontvang een melding wanneer dit item weer beschikbaar is.",
    email_field_label: "Email",
    button_label: "Laat me weten",
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: '',
    newsletter_subscribe_label: "Mis niets! Meld me aan voor de nieuwsbrief.",
    additional_styles: `
      @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400&display=swap');
      @import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300&display=swap');
      .klaviyo-modal h1, h2, h3, h4, h5, h6 { font-family: 'Oswald', sans-serif !important; }
      .klaviyo-modal p, .klaviyo-email { font-family: 'Roboto Condensed', sans-serif !important; font-weight: 300; }
    `,
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#5f7257",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#5f7257",
    success_text_color: "#ffffff"
  }
});

// Klaviyo & LearnQ Add to Cart Tracking
document.addEventListener("DOMContentLoaded", function() {
  const _learnq = window._learnq || [];
  const addToCartButtons = document.querySelectorAll(".product-form__cart-submit, .add-to-cart");

  addToCartButtons.forEach(button => {
    button.addEventListener("click", function() {
      const item = {
        item_name: button.dataset.productName || "Unknown Product",
        item_id: button.dataset.productId || "N/A",
        price: button.dataset.productPrice || "0.00",
        quantity: 1
      };

      const userEmail = "user@example.com"; // replace dynamically
      _k.push(["identify", { email: userEmail }]);
      _k.push(["track", "Added to Cart", {
        value: item.price,
        items: [{ product_id: item.item_id, name: item.item_name, quantity: 1, price: item.price }]
      }]);

      _learnq.push(["track", "Added to Cart", item]);
      console.log("Tracked Add to Cart:", item);
    });
  });
});

// Google Tag Manager Add to Cart Event
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    if (event.target.matches('[data-add-to-cart]')) {
      const product = event.target.closest('[data-product-id]');
      if (product) {
        const productId = product.dataset.productId;
        const productName = product.dataset.productName;
        const productPrice = product.dataset.productPrice;

        if (productId && productName && productPrice) {
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              items: [{ item_id: productId, item_name: productName, price: productPrice, quantity: 1 }]
            }
          });
        }
      }
    }
  });
});

// Remove From Cart
function triggerRemoveFromCartEvent(title, productId, variantId, price) {
  window.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      remove: {
        products: [{ name: title, id: productId, price: price, quantity: 1, currency: 'EUR' }]
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-remove-item]');
    if (button) {
      const title = button.dataset.productTitle;
      const productId = button.dataset.productId;
      const variantId = button.dataset.variantId;
      const price = button.dataset.productPrice;

      if (title && productId && variantId && price) {
        triggerRemoveFromCartEvent(title, productId, variantId, price);
      }
    }
  });
});

// View Cart Event
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/cart')) {
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        currency: 'EUR',
        items: []
      }
    });
  }
});

// Scroll Depth Event
(function() {
  let scrollTriggered = false;
  function calculateScrollDepth() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;
    if (!scrollTriggered && scrollPercent >= 10) {
      scrollTriggered = true;
      window.dataLayer.push({
        event: "gtm.scrollDepth",
        scrollDepth: Math.round(scrollPercent),
        scrollDirection: "vertical",
        scrollThreshold: 10
      });
    }
  }
  window.addEventListener("scroll", calculateScrollDepth);
})();

// Page View Event
window.dataLayer.push({
  event: "page_view",
  ecommerce: {
    items: [
      {
        item_name: window.productData?.title || "N/A",
        item_id: window.productData?.id || "N/A",
        price: window.productData?.price || 0,
        currency: 'EUR',
        quantity: 1
      }
    ]
  }
});

// Product Impressions on Collection/Search Pages
if (
  location.pathname.includes('/collections/') ||
  location.pathname.includes('/search') ||
  location.pathname.includes('/products') ||
  location.pathname.includes('/category')
) {
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      items: window.productList || []
    }
  });
}

